import LecturesPage from "../../features/dashboard/lectures/LecturesPage";

function LecturesDB() {
  return <LecturesPage />;
}

export default LecturesDB;
